import React from "react";
import style from "./ActivityGrid.module.css";

function ActivityGrid({ activity }) {
	// const squares = Array.from({ length: 119 });
	const squares = Array.from({ length: 266 });

	function calculateDate(index) {
		const today = new Date();
		const date = new Date(today);
		date.setDate(today.getDate() - (squares.length - 1 - index));
		return date.toLocaleDateString("en-GB").replace(/\//g, ".");
	}

	function formatDateForComparison(date) {
		const d = new Date(date);
		return d.toISOString().split("T")[0];
	}

	function isDateActive(index) {
		const date = new Date();
		date.setDate(date.getDate() - (squares.length - 1 - index));
		const formattedDate = formatDateForComparison(date);
		return activity.includes(formattedDate);
	}

	return (
		<div className={style.card}>
			<div className={style.grid}>
				{squares.map((_, index) => {
					return (
						<div
							key={index}
							className={`${style.field} ${
								index == squares.length - 1 ? style.current : ""
							} ${isDateActive(index) ? style.active : ""}`}
						>
							<div className={style.date}>
								{calculateDate(index)}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default ActivityGrid;
